<template>
  <svg width="34" height="33" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="Vector"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.9992 14.6C18.9088 14.6 20.7401 13.8414 22.0904 12.4911C23.4407 11.1409 24.1992 9.30951 24.1992 7.39995C24.1992 5.49039 23.4407 3.65904 22.0904 2.30878C20.7401 0.958521 18.9088 0.199951 16.9992 0.199951C15.0897 0.199951 13.2583 0.958521 11.9081 2.30878C10.5578 3.65904 9.79922 5.49039 9.79922 7.39995C9.79922 9.30951 10.5578 11.1409 11.9081 12.4911C13.2583 13.8414 15.0897 14.6 16.9992 14.6ZM0.199219 36.2C0.199219 33.9937 0.633764 31.8091 1.47804 29.7709C2.32232 27.7326 3.5598 25.8806 5.11982 24.3206C6.67985 22.7605 8.53187 21.5231 10.5701 20.6788C12.6084 19.8345 14.793 19.4 16.9992 19.4C19.2054 19.4 21.39 19.8345 23.4283 20.6788C25.4666 21.5231 27.3186 22.7605 28.8786 24.3206C30.4386 25.8806 31.6761 27.7326 32.5204 29.7709C33.3647 31.8091 33.7992 33.9937 33.7992 36.2H0.199219Z"
      fill="#C7CDD0"
    />
  </svg>
</template>
